import { memo } from 'react';

import CheckmarkFilledIconSVG from '@/assets/checkmark-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICheckmarkFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CheckmarkFilledIconSVG} {...props} />
);

export const CheckmarkFilledIcon = memo(ICheckmarkFilledIcon) as typeof ICheckmarkFilledIcon;
